import { createAction } from '@reduxjs/toolkit';

export const SET_BREAKING_PATH = 'SET_BREAKING_PATH';

export const setBreakingPath = createAction(
    SET_BREAKING_PATH,
    (path: string) => ({ payload: path }),
);
